// swr.js

(function(window, document, $, undefined) {
  var SWR = {};

  function expose() {
    var oldSWR = window.SWR;

    SWR.noConflict = function() {
      window.SWR = oldSWR;
      return this;
    };

    window.SWR = SWR;
  }

  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = SWR;
  } else if (typeof define === 'function' && define.amd) {
    define(SWR);
  }

  if (typeof window !== 'undefined') {
    expose();
  }

}(window, document, window.jQuery));

(function() {
  var permittedHostsnames = [
    'www.swr.de',
    'standby.swr.de'
  ];

  if (-1 === permittedHostsnames.indexOf(window.location.hostname.toLowerCase())) {
    return;
  }

  if ('serviceWorker' in navigator) {
    // Wenn man den Serviceworker auf localhost debuggen möchte muss die sw.js von hand in das Webroot kopiert werden
    var PREFIX = self.origin.includes('http://localhost') ? '/cms' : '';
    try {
      navigator.serviceWorker.register(PREFIX + '/sw.js?KSDGmadS17jg', {scope: PREFIX + '/'})
        .then(function() {
          console.log('Service Worker Registered');
        });
    } catch (error) {
      console.error(error);
    }

    //Falls der Service-Worker nicht funktioniert, kann er unregistered werden.
    //Dazu noch die Registrierung oben ausschalten.
    /*try {
      navigator.serviceWorker.getRegistrations().then(
        function (registrations) {
          for (let registration of registrations) {
            registration.unregister();
          }
        });
    } catch(error) {
      console.error(error);
    }

    try {
      caches.keys().then(cacheNames => {
        return Promise.all(
          cacheNames.map(cacheName => {
            //Alte Caches werden gelöscht:
            console.log('Delete cache ' + cacheName);
            return caches.delete(cacheName);
          })
        );
      });
    } catch(error) {
      console.error(error);
    }*/
  }
}());
